export const REDUX_STATES = {
  DEFAULT_KEY: "listing" + new Date().getTime(),
  DEFAULT_DROPDOWN_KEY: "dropdown" + new Date().getTime(),
  DEFAULT_POST_KEY: "post" + new Date().getTime(),
  DEFAULT_PUT_KEY: "put" + new Date().getTime(),
  DEFAULT_PATCH_KEY: "patch" + new Date().getTime(),
  DEFAULT_DELETE_KEY: "delete" + new Date().getTime(),
  DEFAULT_SELECTED_KEY: "selected" + new Date().getTime(),
  LOADING: "_loading",
  ERROR: "_error",
  RESPONSE: "_response",
  PARAMS: "_params",
  CURRENT_ROUTE: "currentRoute",
  PREVIOUS_ROUTE: "previousRoute",
  USER_SETTING_ACCOUNT: "userSettingAccount",
  USER_SETTING_PASSWORD: "userSettingPassword",
  USER_SETTING_PREFERENCE: "userSettingPreference",
  FORGOT_PASSWORD: "forgotPassword",
  RESET_PASSWORD: "resetPassword",
  COMPANY_LIST: "companyList",
  COMPANY_DETAIL: "companyDetail",
  LOCATION_DETAIL: "locationDetail",
  CREATE_UPDATE_LOCATION: "createUpdateLocation",
  LOCATION_LIST: "locationList",
  LOCATION_COMPANY: "locationCompany",
  LOCATION_STATUS: "locationStatus",
  LOCATION_WAND_TYPE: "locationWandType",
  GET_COMPANY: "companyDetails",
  CREATE_COMPANY: "createCompany",
  UPDATE_COMPANY: "updateCompany",
  USER_LIST: "userList",
  VALIDATE_TOKEN: "validateToken",
  USER_DETAILS: "userDetails",
  LOCATION_DEFAULT_VALUES: "locationDefaultValues",
  COUNTRIES_LIST: "countriesList",
  STATES_LIST: "statesList",
  CITIES_LIST: "citiesList",
  USER_DETAIL: "userDetail",
  USER_DEFAULT_VALUES: "UserDefaultValues",
  USER_EMAIL_ADDRESSES: "userEmailAddress",
  USER_STATUS: "userStatus",
  USER_ROLES: "userRoles",
  VYTELLE_APP_LIST: "vytelleApps",
  ACTIVE_SENSE_COMPANIES: "activeSenseCompanies",
  ACTIVE_SENSE_LOCATIONS: "activeSenseLocations",
  ACTIVE_NETWORK_COMPANIES: "activeNetworkCompanies",
  ACTIVE_NETWORK_LOCATIONS: "activeNetworkLocations",
  ACTIVE_ADVANCE_COMPANIES: "activeAdvanceCompanies",
  ACTIVE_ADVANCE_SATELLITE: "activeAdvanceSatellite",
  ACTIVE_ADVANCE_LABS: "activeAdvanceLabs",
  CREATE_UPDATE_USER: "createUpdateUser",
  EXPORT_USER: "exportUsers",
  RESEND_EMAIL: "resendEmail",
  GET_PREFERENCE: "getPreference",
  RELEASE_NOTES_LIST: "releaseNotesList",
  RELEASE_NOTE_DETAIL: "releaseNoteDetails",
  CREATE_UPDATE_RELEASE_NOTE: "createUpdateReleaseNote",
  RELEASE_NOTE_DEFAULT_VALUES: "releaseNoteDefaultValues",
  DELETE_RELEASE_NOTE: "deleteReleaseNote",
};
